import { Component, OnInit } from '@angular/core';
import { SubscriptionPackage } from '@kodit/core/data-api';
import { AuthService } from '@kodit/core/services';

@Component({
  selector: 'kodit-pocetno-stanje-page',
  templateUrl: './pocetno-stanje-page.component.html',
  styleUrls: ['./pocetno-stanje-page.component.scss']
})
export class PocetnoStanjePageComponent implements OnInit {

  shouldDisplayKupciDobavljaci = false;

  constructor(private _authService: AuthService) { }

  ngOnInit(): void {
    this.shouldDisplayKupciDobavljaci = this._authService.hasPackage([
      SubscriptionPackage[SubscriptionPackage.EFAKTURE],
      SubscriptionPackage[SubscriptionPackage.MALOPRODAJA],
      SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
    ]);
  }

}
